import { render, staticRenderFns } from "./ruinart.vue?vue&type=template&id=c984d8b0&scoped=true"
import script from "./ruinart.vue?vue&type=script&lang=js"
export * from "./ruinart.vue?vue&type=script&lang=js"
import style0 from "./ruinart.vue?vue&type=style&index=0&id=c984d8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c984d8b0",
  null
  
)

export default component.exports